module.exports = __webpack_public_path__ + "img/menu-transfer-white.b1b2bbed.svg";